import * as React from "react";

import { cn } from "@/lib/utils";

/**
 * Wrapper for the shared react-select pickers: an optional glyph inside the
 * control and the error message underneath, matching `Field`.
 *
 * Replaces the `input-group` + `input-group-prepend` the pickers repeated, which
 * rendered the icon as a separate boxed cell glued to the left of the control —
 * a squared, bordered box beside the rounded, borderless fields around it.
 *
 * Pair it with `getReactSelectStyles(theme, { hasIcon: true })`, which leaves
 * the room the glyph needs.
 */
const SelectShell = ({ icon, error, className, children }) => (
  <div className={cn("w-full", className)}>
    <div className="relative">
      {icon && (
        // Exactly one layer above the control and one below the menu.
        // react-select's control is `position: relative`, so with no z-index the
        // glyph paints *behind* it and only shows through the translucent fill —
        // it vanished the moment the control was focused and turned opaque. Too
        // high and it sat on top of the open dropdown of the field above it;
        // `menu` is pinned to 2 in getReactSelectStyles to keep the gap.
        <span
          aria-hidden="true"
          className="pointer-events-none absolute left-3 top-1/2 z-[1] -translate-y-1/2 text-muted-foreground"
        >
          {icon}
        </span>
      )}
      {children}
    </div>

    {error && (
      <p className="mt-1.5 text-xs font-medium text-destructive">{error.message}</p>
    )}
  </div>
);

export { SelectShell };
